import React from 'react';
import AuthorChip from '../../products/components/common/AuthorChip';

export function userDisplayName(u) {
    if (!u) return null;
    const fromParts = [u.firstName, u.lastName].filter(Boolean).join(' ').trim();
    return fromParts || u.displayName || u.name || u.email || null;
}

export function toAvatarProfile(u) {
    if (!u) return null;
    return {
        displayName: userDisplayName(u),
        hasAvatar: u.hasAvatar === true,
        profilePicture: u.profilePicture || u.photoURL || undefined,
    };
}

export function indexUsersById(users = []) {
    const byId = {};
    for (const u of users) {
        const id = u?.id || u?.userId || u?.uid;
        if (id) byId[id] = u;
    }
    return byId;
}

/** Avatar + first/last name for collection list tables. Never shows raw user UUID. */
export default function PersonCell({userId, profile, size, chatParentId}) {
    if (!userId) return '—';
    return (
        <AuthorChip
            userId={userId}
            userDisplayName={userDisplayName(profile) || 'Unknown'}
            flex={undefined}
            avatarProfile={toAvatarProfile(profile)}
            size={size}
            chatParentId={chatParentId}
        />
    );
}
